import React from 'react'

import Grid from '../../../../components/Grid'
import Icon, { EIconId } from '../../../../components/icons'
import HseLogo from '../HseLogo'

const CheckoutHeader: React.FunctionComponent = () => {
  return (
    <header className="py-16 py-8 bg-white border-b-2 border-lightgrey-light sm:py-16">
      <Grid.Container>
        <Grid.Row>
          <Grid.Col className="absolute -translate-x-1/2" style={{ left: '50%' }}>
            <HseLogo />
          </Grid.Col>
          <Grid.Col className="flex-initial ml-auto flex items-center">
            <Icon id={EIconId.SHIELD} className="w-24 mr-4 sm:w-32 sm:mr-8 sm:w-40" />
            <span className="font-bold text-12 sm:text-16">Sicher bestellen</span>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </header>
  )
}

export default CheckoutHeader
